import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Reminder } from './reminder.model';
import { ReminderScheduleType } from './reminder-schedule-type.model';
import { ReminderType } from './reminder-type.model';
import { IGroup } from '../../groups/IGroups';
import { ReminderReviewPeriodModel } from './reminder-review-period.model';

export const loadReminders = createAction(
    '[Reminder/API] Load Reminders',
    props<{ reminders: Reminder[] }>()
);

export const addReminder = createAction(
    '[Reminder/API] Add Reminder',
    props<{ reminder: Reminder }>()
);

export const upsertReminder = createAction(
    '[Reminder/API] Upsert Reminder',
    props<{ reminder: Reminder }>()
);

export const addReminders = createAction(
    '[Reminder/API] Add Reminders',
    props<{ reminders: Reminder[] }>()
);

export const upsertReminders = createAction(
    '[Reminder/API] Upsert Reminders',
    props<{ reminders: Reminder[] }>()
);

export const updateReminder = createAction(
    '[Reminder/API] Update Reminder',
    props<{ reminder: Update<Reminder> }>()
);

export const updateReminders = createAction(
    '[Reminder/API] Update Reminders',
    props<{ reminders: Update<Reminder>[] }>()
);

export const deleteReminder = createAction(
    '[Reminder/API] Delete Reminder',
    props<{ id: number }>()
);

export const deleteReminders = createAction(
    '[Reminder/API] Delete Reminders',
    props<{ ids: number[] }>()
);

export const clearReminders = createAction('[Reminder/API] Clear Reminders');
export const getReminders = createAction('[Reminder/API] Get Reminders');
export const putReminders = createAction(
    '[Reminder.API] Put Reminders',
    props<{ reminders: Reminder[] }>()
);
export const runReminder = createAction(
    '[Reminder.API] Run Reminder',
    props<{ Reminderinstanceid: number }>()
);

export const getReminderTypes = createAction(
    '[Reminder/API] Get Reminder Types'
);
export const loadReminderTypes = createAction(
    '[Reminder/API] Load Reminder Types',
    props<{ reminderTypes: ReminderType[] }>()
);
export const getReminderScheduleTypes = createAction(
    '[Reminder/API] Get Reminder Schedule Types'
);
export const loadReminderScheduleTypes = createAction(
    '[Reminder/API] Load Reminder Schedule Types',
    props<{ reminderScheduleTypes: ReminderScheduleType[] }>()
);
export const getReminderRecipients = createAction(
    '[Reminder/API] Get Reminder Recipients'
);
export const loadReminderRecipients = createAction(
    '[Reminder/API] Load Reminder Recipients',
    props<{ recipients: IGroup[] }>()
);
export const getReminderReviewPeriods = createAction(
    '[Reminder/API] Get Reminder Review Period Types'
);
export const loadReminderReviewPeriods = createAction(
    '[Reminder/API] Load Reminder Review Period Types',
    props<{ reminderReviewPeriods: ReminderReviewPeriodModel[] }>()
);
export const removeReminder = createAction(
    '[Reminder/API] Remove Reminder',
    props<{ id: number }>()
);
export const putRemindersSuccess = createAction(
    '[Reminder/API] Put Reminder Success',
    props<{ reminders: Reminder[] }>()
);
